import { createApi } from '@reduxjs/toolkit/query/react';
import { identityBaseQuery } from '../../lib/axiosBaseQuery';
import { IAppConfig } from './auth.types';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: identityBaseQuery,
  tagTypes: ['AppConfig'],
  endpoints: (builder) => ({
    getAuthOTP: builder.mutation<void, { emailAddress: string }>({
      query: (data) => ({
        url: `Otp/email`,
        method: 'POST',
        data,
      }),
    }),
    registerBusiness: builder.mutation<void, Record<string, any>>({
      query: (data) => ({
        url: `Onboarding/register`,
        method: 'POST',
        data,
      }),
    }),
    getAppConfig: builder.query<IAppConfig, string>({
      query: (id) => ({
        url: `configuration/security/options/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'AppConfig', id }],
    }),
    updateAppConfig: builder.mutation<void, { id: string; data: Record<string, any> }>({
      query: ({ id, data }) => ({
        url: `configuration/security/update/${id}`,
        method: 'POST',
        data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'AppConfig', id }],
    }),
    verifyEmployerCode: builder.query<any, string>({
      query: (code) => ({
        url: `Onboarding/verify/emp/${code}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetAuthOTPMutation,
  useRegisterBusinessMutation,
  useGetAppConfigQuery,
  useUpdateAppConfigMutation,
  useLazyVerifyEmployerCodeQuery,
} = authApi;
